import { Nillable } from '@web/utils';

export class UploadValidationResult {
  private constructor(
    public readonly file: File,
    public readonly isValid: boolean,
    public readonly reason?: Nillable<string>,
  ) {}

  public static valid(file: File): UploadValidationResult {
    return new UploadValidationResult(file, true);
  }

  public static invalid(file: File, reason: string): UploadValidationResult {
    return new UploadValidationResult(file, false, reason);
  }
}
